function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { Button, Heading } from '@domain-group/fe-co-allhomes-design-system';
import WhatsNearbyItem from './nearby-item/whats-nearby-item';
import * as styles from './allhomes-listing-whats-nearby-wrapper.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesListingWhatsNearbyWrapper extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getButtonText", () => this.state.isExpanded ? 'View less' : 'View all');
    _defineProperty(this, "toggleItems", () => {
      this.setState(prevState => ({
        isExpanded: !prevState.isExpanded
      }));
    });
    this.state = {
      isExpanded: false
    };
  }
  render() {
    return ___EmotionJSX("section", null, ___EmotionJSX(Heading, {
      title: "What's nearby"
    }), ___EmotionJSX("div", {
      css: styles.contents(this.props.columns)
    }, this.props.items.map((item, index) => {
      if (!this.state.isExpanded && index >= this.props.maxItems) {
        return null;
      }
      return ___EmotionJSX(WhatsNearbyItem, _extends({
        key: "item-".concat(item.name, "-").concat(item.type, "-").concat(item.distance)
      }, item));
    })), this.props.items.length > this.props.maxItems && ___EmotionJSX(Button, {
      css: styles.viewButton,
      appearance: "secondaryNeutral",
      size: "small",
      icon: this.state.isExpanded ? ___EmotionJSX(ChevronUpIcon, {
        size: "small"
      }) : ___EmotionJSX(ChevronDownIcon, {
        size: "small"
      }),
      iconPosition: "right",
      onClick: this.toggleItems
    }, this.getButtonText()));
  }
}
AllhomesListingWhatsNearbyWrapper.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(WhatsNearbyItem.propTypes)).isRequired,
  maxItems: PropTypes.number,
  columns: PropTypes.number
};
AllhomesListingWhatsNearbyWrapper.defaultProps = {
  maxItems: 2,
  columns: 2
};
export default AllhomesListingWhatsNearbyWrapper;